import { call, put, takeLatest } from "redux-saga/effects";

import {
  jobsStart,
  jobsFailure,
  jobsSuccess,
  clearJobs,
  fetchTotalJobsCountFailure,
  fetchTotalJobsCountSuccess,
  fetchTotalJobsCountStart,
  initAppZoom,
  setAppZoom,
} from "./jobsSlice";

import { fetchJobsApi, fetchTotalJobsCountApi } from "./jobsApi";
import { showToast } from "../../../../components";
function* initAppZoomWorker() {
  try {
    const storedZoom = localStorage.getItem("appZoom");
    const zoom = storedZoom ? Number(storedZoom) : 1;
    //document.body.style.zoom = zoom;
    const baseFontSize = 16;
    document.documentElement.style.fontSize = baseFontSize * zoom + "px";

    yield put(setAppZoom(zoom));
  } catch (error) {}
}

function* appZoomChangeWorker(action) {
  try {
    const zoom = action.payload;
    //document.body.style.zoom = zoom;
    const baseFontSize = 16;
    document.documentElement.style.fontSize = baseFontSize * zoom + "px";

    localStorage.setItem("appZoom", zoom.toString());
  } catch (error) {}
}

function* fetchJobsWorker(action) {
  try {
    const { onSuccess, ...params } = action.payload;
    const response = yield call(fetchJobsApi, params);

    if (response?.data) {
      // Handle new format (jobs + totalCount) for candidate-specific queries
      const responseData = response.data?.data;
      let jobsData = [];
      let totalCount = 0;

      if (responseData?.jobs && Array.isArray(responseData.jobs)) {
        // New format: { jobs: [...], totalCount: number }
        jobsData = responseData.jobs;
        totalCount = responseData.totalCount || 0;
      } else if (Array.isArray(responseData)) {
        // Old format: just an array of jobs
        jobsData = responseData;
      } else {
        jobsData = [];
      }

      yield put(jobsSuccess({ data: jobsData, totalCount }));

      if (onSuccess) onSuccess(jobsData);
    } else {
      const jobsData = [];
      yield put(jobsSuccess({ data: jobsData }));
      yield put(jobsFailure("Failed to fetch Jobs Data"));
    }
  } catch (error) {
    yield put(jobsFailure(error.message));
    showToast(error.message || "Failed to fetch jobs API", "error", 2000);
  }
}

function* fetchTotaljobsCountWorker(action) {
  try {
    const response = yield call(fetchTotalJobsCountApi, action.payload);
    const totalCount = response?.data.data?.[0]?.total || 0;

    yield put(
      fetchTotalJobsCountSuccess({
        data: totalCount,
      }),
    );
  } catch (error) {
    yield put(fetchTotalJobsCountFailure(0));
  }
}

export function* watchNMJobs() {
  yield takeLatest(jobsStart.type, fetchJobsWorker);
  yield takeLatest(fetchTotalJobsCountStart.type, fetchTotaljobsCountWorker);
  yield takeLatest(initAppZoom.type, initAppZoomWorker);
  yield takeLatest(setAppZoom.type, appZoomChangeWorker);
}
